import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';
import Autocomplete from '@mui/material/Autocomplete';

import Bs4Kartoteka from './Bs4Kartoteka';
import Bs4MainDispatch from './Bs4MainDispatch';
import Bs4I18N from './Bs4I18N';

import loginGoogle from './Bs4LoginImages/btn_google_signin_light_normal_web.png'
import loginMicrosoft from './Bs4LoginImages/ms-symbollockup_signin_light.png'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props}/>;
});

const ViewLangSelect = (props) => {

  const handleChange = (event, newValue, type) => {
    // console.log('...Login...handleChange', newValue, type)
    if (props.handleChange) props.handleChange(newValue);
  }

  if (!props.langOptions) return null;

  return (
    <Autocomplete
      value={props.lang}
      options={props.langOptions}
      onChange={handleChange}            
      getOptionLabel={option => option?.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => <TextField {...params} label={'Język'}/>}
    />
  )
}

export default function Bs4Login(props) {
  console.log('...Bs4Login...props...', props);
  const [login, setLogin] = React.useState('');  
  const [password, setPassword] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);  

  const loginTitle = props.loginMessage?.title; // Bs4I18N.getTT("Login to bs4", 'Logowanie do bs4', 'Bs4Login');
  const loginEnter = Bs4I18N.getTT("Enter", 'Wejdź', 'Bs4Login');
  const chooseCancel = Bs4I18N.getTT("Cancel", 'Anuluj', 'Bs4Login');
  const loginSend = Bs4I18N.getTT("Send", 'Wyślij', 'Bs4Login');  
  const forgotPassword = Bs4I18N.getTT("I forgot my password", '?', 'Bs4Login');
  const sessionExpired = Bs4I18N.getTT("Session expired. Log in again", 'Sesja wygasła. Zaloguj się ponownie', 'Bs4Login');
  const enterEmail = Bs4I18N.getTT("Enter your email address", 'Wpisz swój adres e-mail', 'Bs4Login');
  const enterOneTimeCode = Bs4I18N.getTT("Enter the one-time code from the Authenticator app", 'Wprowadź kod jednorazowy z aplikacji Authenticator', 'Bs4Login');
  const continueNext = Bs4I18N.getTT("Continue", 'Dalej', 'Bs4Login');
  const iHaveInviteCode = Bs4I18N.getTT('I have an invite code.', 'Mam kod zaproszenia.', 'Bs4Login');
  const forgetAboutSystem = Bs4I18N.getTT('Forget about this system.', 'Zapomnij o tym systemie.', 'Bs4Login');

  const bs4Form = React.useMemo(() => {    
    if (!props.loginMessage?.pageDetails) return null;
    
    const optionId = props.loginMessage?.pageDetails?.optionId;

    const message = {
      _Komunikat: props.loginMessage?.pageDetails,
    };    

    message._Komunikat.currentCardViewId = 'login_page';
    message._Komunikat.bs4ConstructorMode = false; //true;
    
    const bs4Kartoteka = new Bs4Kartoteka(message);
    console.log('...Bs4Login...Bs4Kartoteka...', bs4Kartoteka);

    const bs4Option = bs4Kartoteka.getBs4Option(optionId); 
    bs4Option.bs4Form.loginProps = props;   
    // bs4Option.bs4Form = new Bs4Form({
    //   bs4KartotekaId: bs4Kartoteka.bs4KartotekaId,
    //   optionId: optionId,
    //   inputId: 0,
    // }, false);
    // bs4Option.bs4Form.createModel();
    console.log('...Bs4Login...Bs4Kartoteka...Bs4Form...', bs4Option.bs4Form);

    return bs4Option.bs4Form;
  }, [props.loginMessage?.pageDetails])

  const [openGetEmail, setOpenGetEmail] = React.useState(false);    
  const [newEmail, setNewEmail] = React.useState('');
  const [newOneTimeCode, setOneTimeCode] = React.useState('');
  const [openLink, setOpenLink] = React.useState(false);    
  const theme = useTheme();
  const [lang, setLang] = React.useState(null); 
  const langOptions = React.useMemo(() => {
    try {      
      const options = Object.entries(props.loginMessage?.langsAvailable).map(([id, [name, name1, name2]]) => {
        return {id, name, name1, name2};
      });
      if (options.length < 1) return null;
      const langCookieStr = Bs4I18N.getLang();
      const langCookie = options.find(option => String(option.id) === langCookieStr);
      const langDefault = options.find(option => String(option.id) === String(props.loginMessage?.defaultLang));
      setLang(langCookie || langDefault || null);
      // console.log('...Login...lang', langCookie, langC, props.loginMessage?.defaultLang, langD);
      return options;
    } catch(error) {
      // console.log('...Login...lang.Object.map', error)
      return null;
    }
  }, [props.loginMessage?.langsAvailable, props.loginMessage?.defaultLang, setLang])

  React.useEffect(() => {    
    if (loginTitle) document.title = loginTitle;

    const closeDialogs = (params) => {
      props.setAskCodeStep2(false);
      setOpenGetEmail(false)
      setOneTimeCode('');
      setNewEmail('');
    }

    Bs4MainDispatch.off('CHANGES_SAVED', closeDialogs);
    Bs4MainDispatch.on('CHANGES_SAVED', closeDialogs);

    return () => {
      Bs4MainDispatch.off('CHANGES_SAVED', closeDialogs);
    }
    
  }, [loginTitle])

  const handleChangeLogin = (event) => {
    setLogin(event.target.value);
  }

  const handleChangeePassword = (event) => {
    setPassword(event.target.value);
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  
  const onKeyDownPassword = (e) => {
    if (e.keyCode === 13) handleClickLogin()
  }

  const handleClickLogin = () => {
    const comCore = 'Bs4AjaxLogin';
    const comEbok = 'Bs4AjaxEbokLogin';
    const com = props.loginType === 'ebok' ? comEbok : comCore;
    const formData = new FormData();
    formData.append('login', login);
    formData.append('password', password);

    const data = Bs4MainDispatch.getParserParams({locale: Bs4I18N.getLang()}, );
    formData.append('allparams', JSON.stringify(data));
    Bs4MainDispatch.commandConsole(com, data);
    fetch(Bs4MainDispatch.getUrlPath(`web.php?com=${com}`), {method: 'POST', body: formData})
    .then(response => {
      return response.text();
    })
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);
        if (returnedJson?.messgs[0]?._Typ === "LOGINOK") {
          window.localStorage.setItem(Bs4MainDispatch.SESSION_EXPIRED_MESSAGE, login);
        } else {
          window.localStorage.setItem(Bs4MainDispatch.SESSION_EXPIRED_MESSAGE, null);
        }
        Bs4MainDispatch.parsingBs4Response(returnedJson, null);
      } catch (e) {        
        console.log(returnedText, com);
        console.log(e);
      }
    })
    .catch((error) => {
      console.log('=== fatch catch');
      console.log(error);
    });
  }

  const handleForgotPassword = (event) => {
    setNewEmail('')
    setOpenGetEmail(true);
  }

  const handleForgotPasswordOk = (event) => {
    Bs4MainDispatch.commandParser('bs4ForgotPass', { email: newEmail, locale: Bs4I18N.getLang()});    
  }
  
  const handleEnterOneTimeCodeKey = (event) => {
    if (event.key === 'Enter' && newOneTimeCode?.length >= 6) {
      handleEnterOneTimeCode(event)
    }
  }

  const handleEnterOneTimeCode = (event) => {
    Bs4MainDispatch.commandParser('bs4AfterLoginCode', { tempId: props.askCodeStep2, code: newOneTimeCode, locale: Bs4I18N.getLang()});
    props.setAskCodeStep2(false);
  }

  const handleLoginGoogle = (event) => {
    Bs4MainDispatch.commandParser('bs4PartnerLogin', { partner: 2, locale: Bs4I18N.getLang()});
  }

  const handleLoginMicrosoft = (event) => {
    Bs4MainDispatch.commandParser('bs4PartnerLogin', { partner: 3, locale: Bs4I18N.getLang()});
  }

  const handleFingerPrint = (event) => {
    const androidBs4 = Bs4MainDispatch.getAndroidBs4();
    const appleBs4 = Bs4MainDispatch.getAppleBs4();

    if (androidBs4) {
      console.log('...FingerPrint...', androidBs4);
      try {
        androidBs4.showBiometricPrompt();
      } catch(error) {
        console.log(error);
        console.log('=== Bs4Logi Error, androidBs4:', androidBs4);
      }      
    } 

    if (appleBs4) {
      console.log('...FingerPrint...', appleBs4);
      try {
        appleBs4.showBiometricPrompt.postMessage({});
      } catch(error) {
        console.log(error);
        console.log('=== Bs4Logi Error, appleBs4:', appleBs4);
      }      
    }
  }

  // $tab['linkForget']='https://translate.bs4server.com/?forgetOld='.$connectionId;
  // $tab['linkNewCode']='https://translate.bs4server.com/?forceNew='.$connectionId;
  const handleIHaveInviteCode = (event) => {
    if (props.loginMessage?.linkNewCode) {
      window.location.href = props.loginMessage.linkNewCode;
    } else {
      console.log(new Error('=== Bs4Logi Error no linkNewCode', props.loginMessage))
    }
  }

  const handleForgetAboutSystem = (event) => {
    if (props.loginMessage?.linkForget) {
      window.location.href = props.loginMessage.linkForget;
    } else {
      console.log(new Error('=== Bs4Logi Error no linkForget', props.loginMessage))
    }
  }  

  const handleLink = (event, link) => {
    console.log('...Link...', link)
    if (parseInt(link.dialog) === 1) setOpenLink(link.url);
    else window.location.href = link.url;
  }  

  const handlCloseGetEmail = (e, reason) => {    
    setOpenGetEmail(false);
  }

  const handlCloseAskCodeStep2 = (e, reason) => {
    if (reason === "backdropClick") return;
    props.setAskCodeStep2(false)
  }

  // const handlClo9seGetEmail = (e, reson) => {
  //   console.log('...close get email...', e, reson);
  // }  

  const handleChangeLang = (newValue) => {
    setLang(newValue);
    Bs4I18N.setLang(newValue?.id);
    Bs4MainDispatch.commandParser('bs4LocaleList', {locale: Bs4I18N.getLang()});
  }

  const mainlogo = Bs4MainDispatch.getUrlPath(props.loginMessage?.mainlogo);
  const photo = Bs4MainDispatch.getUrlPath(props.loginMessage?.photo);
  const bottomlogo = Bs4MainDispatch.getUrlPath(props.loginMessage?.bottomlogo);

  console.log('...Login...', props, langOptions, lang, Bs4I18N.getLang())
  // if (!Boolean(props.login)) return null;
  if (!Boolean(props.loginMessage)) return null;

  return (
    <Dialog fullScreen open={Boolean(props.loginMessage)} TransitionComponent={Transition}>            
      <bs4Form.ViewComponent />
    </Dialog>
  );
}
